import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPublicCases } from "../api";
import { caseNeedsQr } from "../casePresentation";
import type { CaseItem, CaseKind } from "../types";

const tabs: Array<{ value: CaseKind; label: string; description: string }> = [
  { value: "OFFLINE_EVENT", label: "线下活动", description: "大会、年会、发布会、家庭日与现场互动交付" },
  { value: "H5", label: "线上 H5", description: "品牌传播、年度报告、互动游戏与活动预热" },
  { value: "MINI_PROGRAM", label: "小程序", description: "需要微信、支付宝或淘宝端内体验的轻应用" },
];

export function CaseHome() {
  const [kind, setKind] = useState<CaseKind>("OFFLINE_EVENT");
  const [items, setItems] = useState<CaseItem[]>([]);
  const [error, setError] = useState("");
  const [qrCase, setQrCase] = useState<CaseItem | null>(null);

  useEffect(() => {
    setError("");
    listPublicCases(kind).then((data) => setItems(data.items)).catch((reason) => setError(String(reason.message || reason)));
  }, [kind]);

  return <div className="public-shell">
    <header className="public-header">
      <a href="https://vhuiwu.cn" className="brand">微会务 <span>案例中心</span></a>
      <nav><a href="https://vhuiwu.cn">返回官网</a><a href="/admin">内容管理</a></nav>
    </header>
    <main>
      <section className="case-hero">
        <p className="eyebrow">REAL PROJECTS · VERIFIED MATERIALS</p>
        <h1>用真实项目，讲清楚每一次交付</h1>
        <p>线下活动与线上互动独立归档，素材、方案、执行与成果保持可追溯。</p>
      </section>
      <section className="case-browser">
        <div className="case-tabs" role="tablist" aria-label="案例类型">
          {tabs.map((tab) => <button key={tab.value} className={kind === tab.value ? "active" : ""} onClick={() => setKind(tab.value)}>
            <strong>{tab.label}</strong><span>{tab.description}</span>
          </button>)}
        </div>
        {error && <p className="error-panel">案例暂时无法加载：{error}</p>}
        {!error && items.length === 0 && <p className="empty-panel">该分类暂无已发布案例。</p>}
        <div className={`case-grid ${kind !== "OFFLINE_EVENT" ? "digital" : ""}`}>
          {items.map((item) => <article className="case-card" key={item.id}>
            <Link to={`/cases/${item.slug}`} className="case-cover">
              {item.coverUrl ? <img src={item.coverUrl} alt={`${item.title}案例封面`} loading="lazy" /> : <div className="asset-placeholder">待补充已授权封面</div>}
              <span className="kind-badge">{tabs.find((tab) => tab.value === item.kind)?.label}</span>
            </Link>
            <div className="case-copy"><h2><Link to={`/cases/${item.slug}`}>{item.title}</Link></h2><p>{item.summary}</p>
              <div className="tag-row">{item.keywords.slice(0, 4).map((tag) => <span key={tag}>{tag}</span>)}</div>
              {caseNeedsQr(item.kind) && item.qrUrl && <button className="text-action" onClick={() => setQrCase(item)}>扫码体验</button>}
            </div>
          </article>)}
        </div>
      </section>
    </main>
    <footer className="public-footer">© 微会务 · 案例素材均来自真实项目，公开范围以授权状态为准</footer>
    {qrCase && <div className="modal-backdrop" role="presentation" onClick={() => setQrCase(null)}>
      <div className="qr-modal" role="dialog" aria-modal="true" aria-label={`${qrCase.title}扫码体验`} onClick={(event) => event.stopPropagation()}>
        <button className="modal-close" onClick={() => setQrCase(null)} aria-label="关闭">×</button>
        <span className="eyebrow">SCAN TO EXPERIENCE</span><h2>{qrCase.title}</h2>
        <img src={qrCase.qrUrl!} alt={`${qrCase.title}体验二维码`} />
        <p>请使用手机扫码体验，部分小程序需要在对应 App 内打开。</p>
      </div>
    </div>}
  </div>;
}
